import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import logo from "../assets/images/logo.png";
import LoginSidebar from "../components/login-slider";
import googleicon from "../assets/images/google-icon.svg";
import host from "../host";
import { changeAuth } from "../actions/loginAction";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import LoadingButton from "@mui/lab/LoadingButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useGoogleLogin } from "@react-oauth/google";

// import ReCAPTCHA from "react-google-recaptcha";
export const LoginPage = () => {
  const auth = localStorage.getItem("login") === "true";
  const location = useLocation();
  const defaultOptions = {
    loop: true,
    autoplay: true,
  };
  const recaptchaRef = React.createRef();
  const navigate = useNavigate();
  //login functionality begins

  const [isValid, setIsValid] = useState(false);
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email address").required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
  });

  const login = () => {
    setIsValid(true);
    setLoading(true);

    fetch(host.chaturl + "/user/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: formik.values.email,
        password: formik.values.password,
      }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const message = await res.json();
          setIsValid(false);
          setMessage(message?.detail);
          setLoading(false);
        } else {
          const data = await res.json();
          dispatch(changeAuth(true, data.token));
          //const redirectUrl = location.state?.redirect ? location.state?.redirect: '/home';
          //navigate(redirectUrl);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (auth) {
      //Redirect url logic is added because if user is not logged in and tries to access a page which is protected then after login user should be redirected to that page (used for share chat)
      const redirectUrl = location.state?.redirect ? location.state?.redirect : "/home";
      navigate(redirectUrl);
    }
  }, [auth]);

  //login functionality ends

  //google login starts
  const googleLogin = (tokenResponse) => {
    setMessage("");
    setLoading(true);
    fetch(host.chaturl + "/user/google", {
      method: "POST",
      body: JSON.stringify({ credential: tokenResponse }),
      headers: {
        "Content-type": "application/json",
      },
    })
      .then(async (res) => {
        if (res.status === 401) {
          return res.json().then((data) => {
            throw new Error(data.message);
          });
        } else {
          return res.json();
        }
      })
      .then(async (data) => {
        setLoading(false);
        if (data.success) {
          dispatch(changeAuth(true, data.token));
          if (data.user) {
            dispatch(changeAuth(true, data.token));
          } else {
            setMessage("something went wrong");
          }
        } else {
          setMessage(data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      googleLogin(tokenResponse);
    },
  });
  //google login ends

  return (
    <div>
      <div className="auth-page">
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-xxl-6 col-lg-6 col-md-6">
              <LoginSidebar />
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6">
              <div className="auth-full-page-content d-flex p-sm-4 p-4">
                <div className="form-width login-width ">
                  <div className="d-flex flex-column h-100">
                    <div className="auth-content my-auto logincorporate">
                      <div className="mb-4 mb-md-4 text-center">
                        <div className="flip-logo">
                          <Link to="/">
                            <img className=" " src={logo} height={50} />
                          </Link>
                        </div>
                      </div>
                      <div className="welcometext text-center">
                        <h5 className="mb-0">Welcome </h5>
                        <p className="text-muted mt-2">Ngnext - KnowledgeHub : Conversations Beyond Boundaries</p>
                      </div>
                      <div className="mt-4 mb-2">
                        <div className="  other-login-options">
                          <Link
                            to="#"
                            className="  btn-google  "
                            onClick={(e) => {
                              e.preventDefault();
                              setLoading(true);
                              loginGoogle();
                            }}
                          >
                            <span className="">
                              {" "}
                              <img src={googleicon} alt="" />{" "}
                            </span>{" "}
                            Continue with Google{" "}
                          </Link>
                          {/* 
                                 <Link to="#" className='  btn-google  ' >
                                 <span className="" > <img src={microsofticon} alt='' />  </span>  Microsoft
                                 </Link>
                                 <Link to="#" className='  btn-google  ' >
                                 <span className="" > <img src={facebook} alt='' />  </span> Fecabook  </Link>
                                 <Link to="#" className='  btn-google  ' >
                                 <span className="" > <img src={apple} alt='' />  </span>  Apple
                                 </Link> */}
                        </div>
                      </div>
                      <div className="d-flex align-items-center mt-3  ">
                        <hr className="flex-grow-1 bg-dark-4" />
                        <span className="mx-2 text-2 text-muted">OR </span>
                        <hr className="flex-grow-1 bg-dark-4" />
                      </div>
                      <form className=" mt-2" action="index.html">
                        <div className="row">
                          <div className="col-xxl-12 col-lg-12 col-md-12">
                            <div className="form-group">
                              <label className="form-label">
                                {" "}
                                Email <span className="text-danger">*</span>
                              </label>
                              <TextField
                                size="small"
                                type="text"
                                name="email"
                                placeholder="Enter business email"
                                disabled={loading}
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-12 col-lg-12 col-md-12">
                            <div className="form-group">
                              <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <label className="form-label">
                                    Password <span className="text-danger">*</span>
                                  </label>
                                </div>
                                <div className="flex-shrink-0">
                                  <div className="forgotpass">
                                    <Link to="/forgot-password" className=" ">
                                      Forgot password?
                                    </Link>
                                  </div>
                                </div>
                              </div>
                              <div className="input-group auth-pass-inputgroup">
                                <TextField
                                  size="small"
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  placeholder="Enter password"
                                  disabled={loading}
                                  InputProps={{
                                    // <-- This is where the toggle button is added.
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                                          {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                  value={formik.values.password}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={formik.touched.password && Boolean(formik.errors.password)}
                                  helperText={formik.touched.password && formik.errors.password}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-xxl-12 col-lg-12 col-md-12">
                            <div className="form-group">
                              {/* 
                                       <ReCAPTCHA
                                          ref={recaptchaRef}
                                          sitekey="Your client site key"
                                          />
                                       */}
                            </div>
                          </div>
                          {/* <div className="col-xxl-12 col-lg-12 col-md-12">
                            <div className="form-group">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="remember-check"
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="remember-check"
                                >
                                  Remember me
                                </label>
                              </div>
                            </div>
                          </div> */}
                          <div className="col-xxl-12 col-lg-12 col-md-12">
                            <div className="form-group">
                              <LoadingButton
                                style={{ textTransform: "capitalize" }}
                                disabled={!formik.isValid}
                                type="button"
                                variant="contained"
                                className="btn btn-primary w-100  "
                                onClick={(e) => {
                                  e.preventDefault();
                                  login();
                                }}
                                controlled={true}
                                loading={loading}
                              >
                                Log In
                              </LoadingButton>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div className="  text-center notmember">
                        {/* 
                              <div className="whatsapbtn">
                                 <button type="button" onclick="window.open('https://ngnexttest.authlink.me', '_self')" style={{border: 'none', background: 'transparent', outline: 'none', paddingBottom: '10px'}}>
                                 <img className=" " src={otpless_button} height={70} />
                                 </button>
                              </div>
                              */}
                        <p className="text-muted mb-0">
                          {" "}
                          Not a member?
                          <Link to="/sign-up" className="  fw-semibold">
                            {" "}
                            Sign up here{" "}
                          </Link>
                        </p>
                        <div
                          style={{
                            color: "red",
                            fontWeight: "500",
                            marginTop: 5 + "%",
                          }}
                        >
                          {message}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
